import type { Card } from '../types/card.types';

/** Conteos de los KPIs de la pestaña "Tarjetas asignadas" (BF-630). */
export interface CardKpiCounts {
  active: number;
  blocked: number;
  inactive: number;
  noLimit: number;
}

const ACTIVE_STATUSES = new Set<string>(['active', 'enabled']);
const BLOCKED_STATUSES = new Set<string>(['blocked']);
// "Cancelada" no existe: una tarjeta cancelada queda Inactiva (terminal).
const INACTIVE_STATUSES = new Set<string>(['inactive', 'disabled', 'cancelled']);

/** Tarjeta sin límite asignado (el "-" + badge de la columna Límite). */
const hasNoLimit = (card: Card): boolean => !card.creditLimit || card.creditLimit <= 0;

/** Conteos tal como los devuelve el BE en `card-list` con `kpis=true` (BF-629). */
export interface CardKpiApiCounts {
  active?: number;
  blocked?: number;
  inactive?: number;
  no_limit?: number;
}

/** Mapea el contrato del BE (`no_limit`) al modelo del FE (`noLimit`). */
export function mapCardKpis(api: CardKpiApiCounts | null | undefined): CardKpiCounts {
  return {
    active: api?.active ?? 0,
    blocked: api?.blocked ?? 0,
    inactive: api?.inactive ?? 0,
    noLimit: api?.no_limit ?? 0,
  };
}

/**
 * Cuenta los 4 KPIs de resumen a partir de las tarjetas de la empresa.
 *
 * Fallback local (BF-629): el BE ya devuelve los agregados; esto solo se usa si
 * el `card-list` desplegado todavía no trae `kpis`.
 */
export function countCardKpis(cards: Card[]): CardKpiCounts {
  return cards.reduce<CardKpiCounts>(
    (acc, card) => {
      if (ACTIVE_STATUSES.has(card.status)) acc.active += 1;
      else if (BLOCKED_STATUSES.has(card.status)) acc.blocked += 1;
      else if (INACTIVE_STATUSES.has(card.status)) acc.inactive += 1;

      if (hasNoLimit(card)) acc.noLimit += 1;
      return acc;
    },
    { active: 0, blocked: 0, inactive: 0, noLimit: 0 },
  );
}
